import i18next from 'i18next';
import { Updater } from 'widgets-for-react';
import { Subscription } from 'subscription/subscriptionState';
import {
  buildValidator,
  isValidatorPassed,
  Validator,
  validatorBuilders,
  ValidatorResult,
  validatorResultBuilders
} from "validator/validator";

export type PaymentFrequency = "monthly"|"yearly"

export const emptySubscription : Subscription = {}

const subscriptionSelectorValidator = buildValidator<Subscription>({
  Id:[b => b.ne(-1), validatorBuilders.number("Id", () => i18next.t(`subscriptionValidators:Subscription`))]
})

export type SubscriptionSelectorState = {
  input:Subscription
  validator:Validator<Subscription, Subscription>,
  validatorResult:ValidatorResult
  isValid():boolean
}

export const initialSubscriptionSelectorState = (currentSubscription?:Subscription) : SubscriptionSelectorState => {
  const initialSubscription = currentSubscription || emptySubscription
  return ({
    input:initialSubscription,
    validator:subscriptionSelectorValidator.setValueToValidate(initialSubscription,initialSubscription),
    validatorResult:validatorResultBuilders.validating(""),
    isValid:function(this:SubscriptionSelectorState) { 
      return isValidatorPassed(this.validatorResult) && 
              (currentSubscription == undefined || currentSubscription?.Id == undefined || currentSubscription?.Id != this.input.Id) 
    }
  })
}

// export const fieldUpdater = <s>() => <k extends keyof s>(k:k) => 
//   (u:Updater<s[k]>) : Updater<s> => s => ({...s, [k]:u(s[k])})

export const subscriptionSelectorStateUpdaters = {
  input:(u:Updater<SubscriptionSelectorState["input"]>) : Updater<SubscriptionSelectorState> =>
    s => {
      const newInput = u(s.input)
      return ({...s, input:newInput, validator:s.validator.setValueToValidate(newInput, newInput)})
    },
  validation:(u:Updater<SubscriptionSelectorState["validator"]>) : Updater<SubscriptionSelectorState> =>
    s => {
      const newValidator = u(s.validator)
      return ({...s, validator:newValidator, validatorResult:newValidator.evaluateResult() })
    },  
}
